/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import i18n from "@/plugins/i18n/translations";

const NotFound = () => import("./screens/NotFound.vue");
const Unauthorized = () => import("./screens/Unauthorized.vue");

const Login = () => import("./screens/login/Login.vue");
const LoginUnico = () => import("./screens/login/LoginUnico.vue");
const LoginSupplier = () => import("./screens/login/LoginSupplier.vue");
const InviteAccept = () => import("./screens/inviteSupplier/InviteAccept.vue");

const NewSupplierOffer = () => import("./screens/supplierOffer/NewSupplierOffer.vue");

// Home
const Page = () => import("./screens/Page.vue");
const Home = () => import("./screens/Home.vue");

// Gestão de Usuários
const Actor = () => import("./screens/actor/Actor.vue");
const UsersList = () => import("./screens/user/UsersList.vue");
const User = () => import("./screens/user/User.vue");
const LogList = () => import("./screens/log/LogList.vue");

// Cadastros
const CompanyList = () => import("./screens/company/CompanyList.vue");
const Company = () => import("./screens/company/Company.vue");
const CompanyGroupList = () => import("./screens/companyGroup/CompanyGroupList.vue");
const Family = () => import("./screens/family/Family.vue");
const RequirementList = () => import("./screens/requirement/RequirementList.vue");
const RequirementListSimple = () => import("./screens/requirement/RequirementListSimple.vue");
const RequirementFormSimple = () => import("./screens/requirement/RequirementFormSimple.vue");
const MaskList = () => import("./screens/mask/MaskList.vue");
const RequirementGroupList = () => import("./screens/requirementGroup/RequirementGroupList.vue");
const WorkflowList = () => import("./screens/workflow/WorkflowList.vue");
const FamilyRequirements = () => import("./screens/family/FamilyRequirements.vue");
const RequirementAdd = () => import("./screens/requirement/RequirementAdd.vue");
const RequirementEdit = () => import("./screens/requirement/RequirementEdit.vue");
const SystemRequirementEdit = () => import("./screens/requirement/SystemRequirementEdit.vue");
const WorkflowDetails = () => import("./screens/workflow/WorkflowDetails.vue");
const WorkflowMacro = () => import("./screens/workflow/WorkflowMacro.vue");
const WorkflowType = () => import("./screens/workflowType/WorkflowType.vue");
const Translation = () => import("./screens/translation/Translation.vue");
const ConditionScreen = () => import("./screens/requirement/ConditionScreen.vue");

// Fornecedores/Clientes
const EnterpriseList = () => import("./screens/enterprise/Enterprise.vue");
const VendorsList = () => import("./screens/vendorsList/VendorsList.vue");
const NewInviteSupplier = () => import("./screens/inviteSupplier/NewInviteSupplier.vue");
const Masker = () => import("./screens/mask/Masker.vue");
const SupplierOfferList = () => import("./screens/supplierOffer/SupplierOfferList.vue");
const SupplierExport = () => import("./screens/export/SupplierExport.vue");
const SaneamentoLoad = () => import("./screens/saneamentoLoad/SaneamentoLoad.vue");
const Supplier = () => import("./screens/supplier/Supplier.vue");

// Materiais
const ProtocolOpening = () => import("./screens/materials/ProtocolOpening.vue");
const ProtocolList = () => import("./screens/materials/ProtocolList.vue");
const MaterialList = () => import("./screens/materials/MaterialList.vue");
const Material = () => import("./screens/material/Material.vue");

// Relatórios
const ExpiredRequirementList = () => import("./screens/expiredRequirement/ExpiredRequirementList.vue");
const EmailActivityList = () => import("./screens/email/Email.vue");
const InviteFollowUp = () => import("./screens/inviteFollowUp/InviteFollowUp.vue");
const Blacklist = () => import("./screens/blackList/BlackList.vue");

// Client
const SupplierClientList = () => import("./screens/client/SupplierClientList.vue");
const ClientList = () => import("./screens/client/ClientList.vue");

// Sistema
const ChangeLog = () => import("./screens/changelog/ChangeLog.vue");
const Configuration = () => import("./screens/configuration/Configuration.vue");

// Avulsos
const Redirect = () => import("./screens/redirect/Redirect.vue");
const RequirementResponseScreen = () => import("./screens/requirement/RequirementResponseFormPage.vue");

Vue.use(Router);

const pageChildren = [
	// Home
	{
		path: "/home",
		name: "home",
		meta: { permissionName: "home" },
		component: Home
	},

	// Gestão de Usuários
	{
		path: "/users",
		name: "users",
		meta: { permissionName: "users" },
		component: UsersList
	},
	{
		path: "/user/:idUser/:type",
		name: "addEditUser",
		meta: {
			permissionName: "users",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.users"),
				i18n.t("server.menus.registers.user")
			]
		},
		component: User,
		props: true
	},
	{
		path: "/actors",
		name: "actors",
		meta: { permissionName: "actors" },
		component: Actor
	},
	{
		path: "/logList",
		name: "logList",
		meta: { permissionName: "logList" },
		component: LogList
	},

	// Cadastros
	{
		path: "/company",
		name: "company",
		meta: { permissionName: "company" },
		component: CompanyList
	},

	{
		path: "/company",
		name: "newCompany",
		meta: {
			permissionName: "company",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.company"),
				i18n.t("server.menus.registers.companyNew")
			]
		},
		component: Company
	},

	{
		path: "/company/:idCompany/:pageType",
		name: "editCompany",
		meta: {
			permissionName: "company",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.company"),
				i18n.t("server.menus.registers.companyEdit")
			]
		},
		component: Company,
		props: true
	},

	{
		path: "/CompanyGroup",
		name: "companyGroup",
		meta: { permissionName: "companyGroup" },
		component: CompanyGroupList
	},

	{
		path: "/family",
		name: "family",
		meta: { permissionName: "family" },
		component: Family
	},
	{
		path: "/familyRequirements/:id",
		name: "familyRequirements",
		meta: {
			permissionName: "familyRequirements",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.family"),
				i18n.t("server.menus.registers.requirement")
			]
		},
		component: FamilyRequirements,
		props: true
	},

	{
		path: "/maskList",
		name: "maskList",
		meta: { permissionName: "maskList" },
		component: MaskList
	},
	{
		path: "/masker",
		name: "masker",
		meta: {
			permissionName: "maskList",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.maskList"),
				i18n.t("server.menus.registers.mask")
			]
		},
		component: Masker
	},
	{
		path: "/masker/:maskId",
		name: "editMask",
		meta: {
			permissionName: "maskList",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.maskList"),
				i18n.t("server.menus.registers.mask")
			]
		},
		component: Masker,
		props: true
	},
	{
		path: "/requirement",
		name: "requirement",
		meta: { permissionName: "requirement" },
		component: RequirementList
	},
	{
		path: "/requirement/add",
		name: "newRequirement",
		meta: {
			permissionName: "requirement",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.requirement"),
				i18n.t("server.menus.registers.requirementNew")
			]
		},
		component: RequirementAdd
	},
	{
		path: "/requirement/:requirementId",
		name: "editRequirement",
		meta: {
			permissionName: "requirement",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.requirement"),
				i18n.t("server.menus.registers.requirementEdit")
			]
		},
		component: RequirementEdit,
		props: true
	},
	{
		path: "/systemRequirement/:requirementId",
		name: "editSystemRequirement",
		meta: {
			permissionName: "requirement",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.systemRequirement"),
				i18n.t("server.menus.registers.systemRequirementEdit")
			]
		},
		component: SystemRequirementEdit,
		props: true
	},
	{
		path: "/requirementGroup",
		name: "requirementGroup",
		meta: { permissionName: "requirementGroup" },
		component: RequirementGroupList
	},
	{
		path: "/requirement/condition",
		name: "requirementCondition",
		meta: {
			permissionName: "requirement",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.requirement"),
				i18n.t("pages.requirement.condition.title")
			]
		},
		component: ConditionScreen
	},
	{
		path: "/requirement/:requirementId/condition",
		name: "editRequirementCondition",
		meta: {
			permissionName: "requirement",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.requirement"),
				i18n.t("pages.requirement.condition.title")
			]
		},
		component: ConditionScreen,
		props: true
	},
	{
		path: "/workflow",
		name: "workflow",
		meta: { permissionName: "workflow" },
		component: WorkflowList
	},
	{
		path: "/workflow/new",
		name: "newWorkflow",
		meta: {
			permissionName: "workflow",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.workflow"),
				i18n.t("server.menus.registers.workflowNew")
			]
		},
		component: WorkflowDetails
	},
	{
		path: "/workflow/edit/:id",
		name: "editWorkflow",
		meta: {
			permissionName: "workflow",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.workflow"),
				i18n.t("server.menus.registers.workflowEdit")
			]
		},
		component: WorkflowDetails,
		props: true
	},
	{
		path: "/workflow/macro/:id",
		name: "macroWorkflow",
		meta: {
			permissionName: "workflow",
			breadCrumbs: [
				i18n.t("server.menus.groups.registers"),
				i18n.t("server.menus.registers.workflow"),
				i18n.t("server.menus.registers.workflowMacro")
			]
		},
		component: WorkflowMacro,
		props: true
	},
	{
		path: "/workflowType",
		name: "workflowType",
		meta: { permissionName: "workflowType" },
		component: WorkflowType,
		props: true
	},
	{
		path: "/translation",
		name: "translation",
		meta: { permissionName: "translation" },
		component: Translation
	},

	// Fornecedores
	{
		path: "/enterpriseList",
		name: "enterpriseList",
		meta: { permissionName: "enterpriseList" },
		component: EnterpriseList,
		props: { isCustomerInvite: true }
	},
	{
		path: "/vendorList",
		name: "vendorList",
		meta: { permissionName: "vendorList" },
		component: VendorsList,
		props: { isCustomerModel: true }
	},
	{
		path: "/supplier/:idSupplier/:homologationStatus",
		name: "supplier",
		meta: {
			permissionName: "vendorList",
			breadCrumbs: [i18n.t("server.menus.groups.supplierClients"), i18n.t("server.menus.supplierClients.vendorList")]
		},
		component: Supplier,
		props: true
	},
	{
		path: "/inviteSupplier",
		name: "inviteSupplier",
		meta: { permissionName: "inviteSupplier" },
		component: NewInviteSupplier
	},
	{
		path: "/inviteDetails/:idInvite/:actualStepActor/:screenType/:idStep/:idClient",
		name: "inviteDetails",
		meta: {
			permissionName: "inviteDetails",
			breadCrumbs: [
				i18n.t("server.menus.groups.supplierClients"),
				i18n.t("server.menus.supplierClients.enterpriseList")
			]
		},
		component: NewInviteSupplier,
		props: true
	},
	{
		path: "/offerList",
		name: "offerList",
		meta: { permissionName: "offerList" },
		component: SupplierOfferList
	},
	{
		path: "/exportSupplier",
		name: "exportSupplier",
		meta: { permissionName: "exportSupplier" },
		component: SupplierExport
	},
	{
		path: "/saneamentoLoad",
		name: "saneamentoLoad",
		meta: { permissionName: "saneamentoLoad" },
		component: SaneamentoLoad
	},
	{
		path: "/expiredRequirement",
		name: "expiredRequirement",
		meta: { permissionName: "expiredRequirement" },
		component: ExpiredRequirementList
	},
	{
		path: "/blacklist",
		name: "blacklist",
		meta: { permissionName: "blacklist" },
		component: Blacklist
	},

	//Materiais
	{
		path: "/protocolOpening",
		name: "protocolOpening",
		meta: {
			permissionName: "protocolOpening"
		},
		component: ProtocolOpening
	},
	{
		path: "/protocolDetails/:idInvite/:actualStepActor/:screenType/:idStep/:idClient",
		name: "protocolDetails",
		meta: {
			permissionName: "protocolOpening",
			breadCrumbs: [i18n.t("server.menus.groups.materials"), i18n.t("server.menus.materials.protocolList")]
		},
		component: ProtocolOpening,
		props: true
	},
	{
		path: "/protocolList",
		name: "protocolList",
		meta: {
			permissionName: "protocolList"
		},
		component: EnterpriseList,
		props: { isCustomerInvite: false }
	},
	{
		path: "/materialList",
		name: "materialList",
		meta: {
			permissionName: "materialList"
		},
		component: VendorsList,
		props: { isCustomerModel: false }
	},
	{
		path: "/material/:materialId",
		name: "material",
		meta: {
			permissionName: "materialList",
			breadCrumbs: [i18n.t("server.menus.groups.materials"), i18n.t("server.menus.groups.materials")]
		},
		component: Material,
		props: true
	},

	// Relatórios
	{
		path: "/emailActivity",
		name: "emailActivity",
		meta: { permissionName: "emailActivity" },
		component: EmailActivityList
	},
	{
		path: "/inviteFollowUp",
		name: "inviteFollowUp",
		meta: { permissionName: "inviteFollowUp" },
		component: InviteFollowUp
	},

	// Clientes
	{
		path: "/client",
		name: "client",
		meta: { permissionName: "client" },
		component: SupplierClientList
	},
	{
		path: "/supplier/:idSupplier/client/:idClient",
		name: "supplierClient",
		meta: {
			permissionName: "client",
			breadCrumbs: [i18n.t("server.menus.groups.clients"), i18n.t("server.menus.clients.client")]
		},
		component: Supplier,
		props: true
	},
	{
		path: "/clientList",
		name: "clientList",
		meta: {
			permissionName: "configuration",
			breadCrumbs: [i18n.t("server.menus.groups.clients")]
		},
		component: ClientList
	},

	// Sistema
	{ path: "/changeLog", name: "changeLog", meta: { permissionName: "changeLog" }, component: ChangeLog },
	{ path: "/configuration", name: "configuration", meta: { permissionName: "configuration" }, component: Configuration }
];

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/page",
			name: "Page",
			component: Page,
			children: pageChildren
		},
		{
			path: "/inviteOffer",
			name: "inviteOfferWithoutKey",
			meta: { permissionName: "inviteOffer" },
			component: NewSupplierOffer
		},
		{
			path: "/inviteOffer/:clientKey",
			name: "inviteOffer",
			component: NewSupplierOffer,
			props: true
		},
		{
			path: "/redirect",
			name: "redirect",
			props: true,
			component: Redirect
		},
		{
			path: "/",
			name: "Login",
			component: Login
		},
		{
			path: "/login",
			name: "LoginUnico",
			props: true,
			component: LoginUnico
		},
		{
			path: "/login/:randomKey/:idClient/:languageId",
			name: "LoginSupplier",
			component: LoginSupplier
		},
		{
			path: "/invite/:idInvite/accept",
			name: "InviteAccept",
			component: InviteAccept,
			props: true
		},
		{
			path: "/createSinInvite/:language?",
			name: "RequirementResponseFormPage",
			component: RequirementResponseScreen,
			props: true,
			meta: { isIframe: true }
		},
		{
			path: "/RequirementListSimple/:language?",
			name: "RequirementListSimple",
			component: RequirementListSimple,
			props: true,
			meta: { isIframe: true }
		},
		{
			path: "/requirementSimple/add",
			name: "requirementSimple-add",
			component: RequirementFormSimple,
			props: true,
			meta: { isIframe: true }
		},
		{
			path: "/requirementSimple/edit/:requirementId",
			name: "requirementSimple-edit",
			component: RequirementFormSimple,
			props: true,
			meta: { isIframe: true }
		},
		{
			path: "/requirementSimple/:requirementId/condition",
			name: "requirementSimple-edit-condition",
			component: ConditionScreen,
			props: true,
			meta: { isIframe: true }
		},
		{
			path: "/:catchAll(.*)",
			name: "NotFound",
			component: NotFound
		},
		{
			path: "/error",
			name: "Unauthorized",
			component: Unauthorized
		}
	]
});
